var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"closeSurvey mb-2",on:{"click":_vm.closeSurvey}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'times-circle']}}),_vm._v(" "),_vm._t("default",function(){return [_c('span',{staticClass:"px-1"},[_vm._v("\n        Close Survey\n      ")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }